<template>
  <div id="login">
    <section class="bannerprincipal pb-2">
      <SiteNav></SiteNav>
      <div
        class="col-12 text-center py-3"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <div class="row">
          
        </div>
      </div>
    </section>

    <div
      class="separador text-center mt-5 py-5"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <p class=" fXG amarillo">Dashboard QR</p>
    </div>

    <div class="container-fluid" >
      <!-- <div class="row pb-5">
        <div class="col-12 blockd fG amarillo">Semana 1</div>
      </div>-->

      <div class="row py-5" data-aos="fade-up"
      data-aos-delay="600">
        <div class="col-md-6 offset-md-3 text-center">
          
          <router-link class="btnaction" to="/lector/scan">
            Escanear
          </router-link>

        </div>
      </div>

      <div class="row py-5" data-aos="fade-up"
      data-aos-delay="600">
        <div class="col-md-6 offset-md-3 text-center">
          
          <router-link class="btnaction" to="/lector/codigo">
            Buscar código
          </router-link>

        </div>
      </div>


      <div class="row py-5" data-aos="fade-up"
      data-aos-delay="600">
        <div class="col-md-6 offset-md-3 text-center">
          
          <router-link class="btnaction" to="/lector/email">
            Buscar email
          </router-link>

        </div>
      </div>


      <div class="row py-5" data-aos="fade-up"
      data-aos-delay="600">
        <div class="col-md-6 offset-md-3 text-center">
          
          <router-link class="btnaction" to="/lector/busqueda">
            Búsqueda general
          </router-link>

        </div>
      </div>


      <!-- <div class="row py-5" data-aos="fade-up"
      data-aos-delay="600">
        <div class="col-md-6 offset-md-3 text-center">
          
          <router-link class="btnaction2" to="/lector/dashboard/patrocinadores">
            COMIDA PATROCINADORES
          </router-link>

        </div>
      </div> -->


      


      <!-- <div class="row py-5" data-aos="fade-up"
      data-aos-delay="600">
        <div class="col-md-6 offset-md-3 text-center">
          
          <router-link class="btnaction" to="/lector/registro">
            Registrar Asistente
          </router-link>

        </div>
      </div> -->


      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
    </div>

    <Footer></Footer>
    <!-- <Glyphicons></Glyphicons> -->
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNavLector";

import * as fb from "../firebase";
import * as moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);



export default {
  components: {
    Footer,
    SiteNav,

    // Glyphicons,
  },
  data() {
    return {
      reenvioForm:{
        codigo: ""
      },
      
      preForm: {
        codigo:"",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        codigo:"",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa:"",
        puesto:"",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica:false,
        talla_guantes: "",
        talla_cubrebocas: "",
        terminos: false
      },
      
      columnsRegistros: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email_user",
        "codigo_pais",
        "telefono",
        "movil",
        "torneo",
        "handicap",
        "talla_tops",
        "clinica",
        "talla_guantes",
        "talla_cubrebocas",
        "terminos"
      ],
      columnsInvitados: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email_user",
        "codigo_pais",
        "telefono",
        "movil",
        
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        editableColumns: [],
        sortable: [],
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registros: [],
      invitados: [],
      user: null,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = JSON.parse(localStorage.getItem("user_copaprosa2021"));

    this.getRegistros();
  },
  methods: {
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistros() {
      console.log("get registros");

      const https = require("https");
      var qData = {
        no_cliente: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistros.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registros = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });
      

      this.$store.dispatch("showLoader", true);

      
      let thes = this;
      const https = require("https");
      var qData = this.preForm;


      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo)
              console.log(res.datos[0].email)
              
              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;
              
              this.preForm = {
                codigo:"",
                apellido_paterno: "",
                email: "",
              };
              
             
            } else if (res.status === "reenvio"){
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo:"",
                apellido_paterno: "",
                email: "",
              };
             
            }else {
              swal.fire("Oops", res.msg, "warning");
             
             
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );


    },
    reenvio() {
     
      console.log({ reenvio: this.reenvioForm });
      

      this.$store.dispatch("showLoader", true);

      
      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;


      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");

            
              
            
             
            } else {
              swal.fire("Oops", res.msg, "warning");
             
             
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );


    },
    signup(e) {
      e.preventDefault();


      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
              
            }else {
              swal.fire("Oops", res.msg, "warning");
              
              
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        password: "",
        estado: "",
        no_cliente: "",
      };
      this.centroForm = {
        clasificacion: "",
        no_cliente: "",
        nombre_completo: "",
        cedis: "",
        objetivo_semanal: "",
      };
    },
  },
};
</script>

